<template>
    <div class="colunm-title">
        <div class="title-box"><h3>{{msg[0]}}</h3><span class="more" v-if="msg[1]"><router-link :to="{name:'scriptlist'}">更多></router-link></span></div>
    </div>
</template>

<script>
export default {
  name: 'ColunmTitle',
  props: {
    msg:''
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.colunm-title{
    height:44px;
    padding:24px;
    overflow:hidden;
    background:#fff;
    h3{
        height:44px;
        line-height:44px;
        font-size:28px;
        padding-left:20px;
        color:#333;
        text-align:left;
        position:relative;
        display:inline-block;
        float:left;
    }
    h3::before{
        content:'';
        width:4px;
        height:18px;
        background:#bf0000;
        position:absolute;
        left:0;
        top:50%;
        transform:translateY(-9px);
    }
    .more{
        display:inline-block;
        height:44px;
        line-height:44px;
        float:right;
        color:#999;
        font-size:22px;
        a{
            color:#333 !important;
        }
    }
}
</style>
